import { gql } from '@apollo/client';

export const updateSupplierMutation = gql`
  mutation updateSupplier($supplierRegister: SupplierRegisterInput!) {
    updateSupplier(UpdateSupplierInput: $supplierRegister) {
      message
    }
  }
`;
